<div class="loader-container" [hidden]="!isLoading">
    <div class="loader">
        <fn-loader></fn-loader>
    </div>
</div>
<router-outlet></router-outlet>
<fn-screen-resolution></fn-screen-resolution>